var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNotifications24Px = function SvgNotifications24Px(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0008 7.95833V12.125L13.0758 13.2C13.6008 13.725 13.2258 14.625 12.4841 14.625H1.50911C0.767442 14.625 0.400775 13.725 0.925775 13.2L2.00078 12.125V7.95833C2.00078 5.39167 3.35911 3.25833 5.75078 2.69167V2.125C5.75078 1.43333 6.30911 0.875 7.00078 0.875C7.69244 0.875 8.25078 1.43333 8.25078 2.125V2.69167C10.6341 3.25833 12.0008 5.4 12.0008 7.95833ZM8.66744 15.4583C8.66744 16.375 7.91744 17.125 7.00078 17.125C6.07578 17.125 5.33411 16.375 5.33411 15.4583H8.66744Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNotifications24Px);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "notifications_24px.4a75e7bdea6784a8d89340910427a7b0.svg";